export const setGTMconsent = enableStorage => {
    if (typeof window !== 'undefined') {
        if (enableStorage) {
            window.gtag('consent', 'update', {
                ad_storage: 'granted',
                ad_user_data: 'granted',
                ad_personalization: 'granted',
                analytics_storage: 'granted',
            });
        } else {
            window.gtag('consent', 'update', {
                ad_storage: 'denied',
                ad_user_data: 'denied',
                ad_personalization: 'denied',
                analytics_storage: 'denied',
            });
        }
    }
};

export const initGTMconsent = () => {
    if (typeof window !== 'undefined') {
        window.gtag('consent', 'default', {
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied',
            analytics_storage: 'denied',
            functionality_storage: 'denied',
            personalization_storage: 'denied',
            security_storage: 'denied',
            wait_for_update: 500,
        });
    }
};

export const trackGaEvent = (event, socialNetworkName, sharedUrl) => {
    return function () {
        if (typeof window !== 'undefined') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event,
                socialNetworkName,
                sharedUrl,
            });
        }
    };
};

export const trackSearchEvent = (event, keyword) => {
    return function () {
        if (typeof window !== 'undefined') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event,
                keyword,
            });
        }
    };
};
